export default "__VITE_ASSET__3SWgzIgD__"